import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import ChatboxSection from '@/sections/contacts/ChatboxSection';
export function Contact() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("contact.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline anchorKey="contact.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative z-10 mx-auto mt-4 flex max-w-[75rem] flex-col gap-6 px-4 lg:mt-5"><ChatboxSection /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="px-4"><div className="flex flex-col gap-12 lg:gap-16">{t2}{t3}</div></div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}